import { defineComponent } from 'vue';
import { useSnackBar } from '@/composition/snackBar';
export default defineComponent({
    setup() {
        const { snackbars, open, close } = useSnackBar();
        return {
            snackbars, open, close
        };
    }
});
